import {Component} from '@angular/core';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'bulk-infohash-v2-busy-indicator',
    templateUrl: 'bulk-infohash-v2-busy-indicator.component.html',
    styleUrls: ['bulk-infohash-v2-busy-indicator.service.scss']
})
export class BulkInfohashV2BusyIndicatorComponent {}


// WEBPACK FOOTER //
// ./src/app/bulkinfohash-v2/bulk-infohash-v2-loading/bulk-infohash-v2-busy-indicator.component.ts